module.exports = __webpack_public_path__ + "static/marcs-mission-0845d9c01e567553b8d5d7a20331549a.jpg";